<section ngClass.lt-sm="small">
  <div class="title-container" fxLayout="row">
    <h2 fxFlex="1 1 auto" class="left-title">Fertig!</h2>
    <h2 fxHide.lt-md class="center-title">Unsere Referenzliste</h2>
    <h2 fxHide.lt-md fxFlex="1 1 auto" class="center-clone">Fertig!</h2>
  </div>
  <div fxLayout="row" fxLayoutAlign="center start">
    <div class="referenzen" fxLayout="column" fxLayoutAlign="center center">
      <div *ngFor="let referenz of referenzen;let i = index" class="kompetenz">
        <div class="title" fxLayout="row" fxLayoutGap="2px" fxLayoutAlign="start center">
          <div>{{referenz.kompetenz}}</div>
          <button mat-icon-button
                  (click)="cookiesAgreed ? referenz.expanded = !referenz.expanded : performCookieCheck()">
            <mat-icon>{{referenz.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
          </button>
        </div>
        <div *ngFor="let branche of referenz.branchen; let i = index">
          <div *ngIf="(isHandset && (i==0 || referenz.expanded)) || !isHandset"
               [ngClass]="{'hide': !isHandset && i > 0 && !referenz.expanded}" class="gallery">
            <app-gallery-scroller [ladenObjects]="branche.ladenObjects"
                                  [noPicObjects]="branche.noPicObjects" [smallImages]="true" [linear]="true"
                                  [showIndividualLabels]="true" individualLabelKey="branche"
                                  [showLabelsOnlyOnFirstItem]="true" [doubleCards]="true" [numberOfDoubleCards]="1"
                                  [blueArrows]="true"></app-gallery-scroller>
          </div>
        </div>
        <div *ngIf="!referenz.expanded" class="description">{{referenz.beschreibung}}</div>
        <button *ngIf="referenz.expanded" mat-flat-button color="accent" class="expand-button"
                (click)="referenz.expanded = !referenz.expanded">
          <span>Weniger aus {{referenz.kompetenz}} anzeigen</span>
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
